import React from "react";
import { Link } from "@sitecore-jss/sitecore-jss-react";
import { fixJavaScriptLinks } from "../lib/javaScriptLinkUtils";

const Footer = (props) => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer-portaalderden">
      <div className="container">
        <ul className="links-left">
          <li>
            <span>&copy; {year} DELA</span>
          </li>
        </ul>
        <ul className="links-left">
          <li>
            <Link field={fixJavaScriptLinks(props.fields.privacyStatement)} />
          </li>
          <li>
            <Link field={fixJavaScriptLinks(props.fields.disclaimer)} />
          </li>
        </ul>
        <ul className="links-right"></ul>
      </div>
    </footer>
  );
};

export default Footer;
